import { xtwhUrls } from '@shared/urls/xtwhUrls';
import { NormalCode } from './../../../shared/utils/normalCode';
import { loginUrls } from '@shared/urls/loginUrls';
import { PublicHttpService } from './../../../routes/teacher/public-http.service';
import { Component, OnInit, Injector } from '@angular/core';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.less'],
})
export class DownloadComponent extends PublicHttpService implements OnInit {
  isHidden = true;
  isIOS: boolean;
  downloadUrl: string;
  androidDownloadUrl: string;
  iosDownloadUrl: string;

  constructor(protected injector: Injector) {
    super(injector);
  }

  /**
   * 获取下载信息
   */
  getAppDownLoadInfo(): void {
    const XML = new XMLHttpRequest();
    XML.open('POST', loginUrls.appDowload.getAppDownLoadInfo, true);
    XML.send(null);
    XML.onreadystatechange = () => {
      if (XML.readyState === 4 && XML.status === 200) {
        // console.log(JSON.parse(XML.responseText));
        const res = JSON.parse(XML.responseText);
        console.log(res);
        if (res.err_code === NormalCode.NORMAL_CODE) {
          this.androidDownloadUrl = res.fileName;
          // this.iosDownloadUrl = "1467158597";
          this.iosDownloadUrl = res.appleId;
        } else {
          this.message.error(res.err_msg);
        }
      }
    };
  }

  /**
   * 下载android版
   */
  downloadAndroid(): void {
    window.open(xtwhUrls.files.downloadApk + `?fileName=${this.androidDownloadUrl}`);
  }

  /**
   * 下载ios版
   */
  dowloadIOS(): void {
    window.open(`https://apps.apple.com/cn/app/id${this.iosDownloadUrl}`);
  }

  ngOnInit() {
    this.downloadUrl = window.location.href;
    this.getAppDownLoadInfo();
    const browser = {
      // tslint:disable-next-line: only-arrow-functions
      versions: (function() {
        const u = navigator.userAgent;
        console.log(u);
        return {
          trident: u.indexOf('Trident') > -1, // IE内核
          presto: u.indexOf('Presto') > -1, // opera内核
          webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
          gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
          mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
          android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
          iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
          iPad: u.indexOf('iPad') > -1, // 是否iPad
          webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
          weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
        };
      })(),
    };
    if (browser.versions.mobile) {
      // 手机
      console.log('手机端');
      this.isHidden = false;
      if (browser.versions.android) {
        // android
        this.isIOS = false;
      } else {
        // ios
        this.isIOS = true;
      }
    } else {
      // 浏览器
      console.log('浏览器');
      this.isHidden = true;
    }
  }
}
